import salesExpensesMSTListPage from './salesExpensesMSTListPage';

export default salesExpensesMSTListPage;
